import React from "react"
import { cn } from "lib/utils"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider"
import { useRenderStyling } from "lib/hooks/useRenderStyling"

export default function LetterPrefixRender(){
  
  const { parseApiData }:any = useTemplatePreviewCtx()
  // const config = getElementConfig("letter_prefix")

  const outerStyling = useRenderStyling("w-full flex flex-col mt-4", "styleObj")
  const innerStyling = useRenderStyling("w-full flex justify-start items-start mt-1", "styleObj")
  const labelStyling = useRenderStyling("w-12", "styleObj")
  const introStyling = useRenderStyling("mt-3", "styleObj")

  return (
    <div id="mm-letter-prefix" {...outerStyling}>
      <div {...innerStyling}>
        <span {...labelStyling}>From:</span>
        <span>{ parseApiData("[[merchant.DBA]]").result } - { parseApiData("[[merchant.Descriptor1]]").result}</span>
      </div>

      <div {...innerStyling}>
        <span {...labelStyling}>To:</span>
        <span>{ parseApiData("[[merchant.Processor.Name]]").result }</span>
      </div>

      <div {...innerStyling}>
        <span {...labelStyling}>RE:</span>
        <span>Chargeback Reversal</span>
      </div>

      <p {...introStyling}>
        { parseApiData("[[merchant.DBA]]").result } offers { parseApiData("[[merchant.BusinessDescription]]").result }
      </p>
    </div>
  )
}